export const getCustomCampaignNameFromFullName = (fullName: string): string => {
    if (fullName && fullName.includes('—')) {
        const campaignName = fullName.split('—');
        const customName = campaignName[1];
        return customName.trim();
    } else {
        return '';
    }
};